export enum COLOR {
    PRIMARY= "#F5821F",
    RED = "#D6482A",
    BLACK = "#000000",
    GREEN = "#4AC66F",
    WHITE= "#FFFFFF",
    OFF_WHITE = "#EAEAEA",
    LIGHT_BG = "#F5F6FA",
    GRAY = "#ACACAC",
    BUTTON_PRIMARY = "#F58220",
    BUTTON_DISABLED = "#898989",
    DARK_GRAY = "#C7C7C7",
    SHADOW = "#00000029",
    PURPLE = "#434175",
    GRAY_BG = "#eeeeee",
    BUTTON_GREEN = "#37ac4a",
}

export enum INPUT_TYPE {
    TEXT = "text",
    NUMBER = "number",
    PASSWORD = "password",
    RADIO = "radio",
    DROPDOWN = "dropdown",
    FILE = "file",
    DATE = "date",
}

export const CC_EMAIL_ID = "support@myshubhlife.com";

export enum ACCEPT_TYPE {
    IMG = "image/img",
    PNG = "image/png",
    JPEG = "image/jpeg",
    PDF = "application/pdf",
    ALL_IMAGE = "image/*",
    JPG = "image/jpg",
}

export enum StyleType {
    ROUNDED_INPUT = "rounded",
    BORDER_BOTTOM_INPUT = "line",
}

export enum MessageType {
    ERROR = "ERROR",
    SUCCESS = "SUCCESS",
}

export const whatsAppLink = "https://api.whatsapp.com/send?phone=917618703970";
